import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  ALL_TEAMS_LIST_START: "ALL_TEAMS_LIST_START",
  TEAMS_SAVE_START: "TEAMS_SAVE_START",
  ALL_TEAMS_LIST_SUCCESS: "ALL_TEAMS_LIST_SUCCESS",
  ALL_TEAMS_LIST_FAILED: "ALL_TEAMS_LIST_FAILED",
  TEAMS_SAVE_SUCCESS: "TEAMS_SAVE_SUCCESS",
  TEAMS_SAVE_FAILED: "TEAMS_SAVE_FAILED",
};

// ============================================ Actions ========================================================
export const allTeamsListStart = (data) => ({
  type: actionType.ALL_TEAMS_LIST_START,
  payload: data,
});

export const allTeamsListsaveStart = (data) => ({
  type: actionType.TEAMS_SAVE_START,
  payload: data,
});

export const allTeamsListSuccess = (data) => ({
  type: actionType.ALL_TEAMS_LIST_SUCCESS,
  payload: data,
});

export const allTeamsListFailed = (data) => ({
  type: actionType.ALL_TEAMS_LIST_FAILED,
  payload: data,
});

export const TeamsSaveSuccess = (data) => ({
  type: actionType.TEAMS_SAVE_SUCCESS,
  payload: data,
});

export const TeamsSaveFailed = (data) => ({
  type: actionType.TEAMS_SAVE_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function allTeamsListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.ALL_TEAMS_LIST_START:
      return {
        ...state,
        loading: true,
      };

    case actionType.TEAMS_SAVE_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.ALL_TEAMS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.ALL_TEAMS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };

    case actionType.TEAMS_SAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case actionType.TEAMS_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* TeamsListSaveSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(TeamsSaveSuccess("Team Added Successfully"));
    } else {
      messagePopup("", "Teams List failed", "error");
      yield put(TeamsSaveFailed("Teams List failed"));
    }
  } catch (error) {
    messagePopup("", "Teams List failed", "error");
    yield put(TeamsSaveFailed("Teams List failed"));
  }
}

export function* allTeamsListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        allTeamsListSuccess({
          allTeamsList: response.data.data.allTeams.Teams,
        })
      );
    } else {
      messagePopup("", "Team List failed", "error");
      yield put(allTeamsListFailed("Team List failed"));
    }
  } catch (error) {
    messagePopup("", "Team List failed", "error");
    yield put(allTeamsListFailed("Team List failed"));
  }
}

//Watcher
export function* watchAllTeamsListSaga() {
  yield takeEvery(actionType.ALL_TEAMS_LIST_START, allTeamsListSaga);
  yield takeEvery(actionType.TEAMS_SAVE_START, TeamsListSaveSaga);
}
